import script from "./recoverpassword.vue?vue&type=script&setup=true&lang=js"
export * from "./recoverpassword.vue?vue&type=script&setup=true&lang=js"

import "./recoverpassword.vue?vue&type=style&index=0&id=14d00ef8&lang=css"

const __exports__ = script;

export default __exports__